import { Injectable } from '@angular/core'
import { BackService } from './back.service'
import { Store, State, Types, Api, User, TokenName } from '../store'

@Injectable() export class InitializeService {

  constructor(private store: Store<State>, private bs: BackService) {}

  public logInByToken(): Promise<any> {
    if (localStorage.getItem(TokenName)) {
      return this.bs.get(Api.auth.logInByToken, 'init').toPromise().then((data: any) => {
        if (data) {
          this.store.dispatch({
            type: Types.UpdateState,
            payload: { user: new User(data) }
          });
        }
      }).catch((err: any) => {
        localStorage.removeItem(TokenName);
        this.store.dispatch({ type: Types.UpdateState, payload: {} });
        Promise.resolve();
      });
    }
    return Promise.resolve(null);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/initialize.service.ts